// Image annotée : points reliés par des lignes fines à des étiquettes
// placées en haut ou en bas de l'image (non cliquable, purement informatif).
// Chaque groupe peut avoir sa couleur (color) et des points agrandis (big).
export const AnnotatedImage = ({ src, alt, groups, testId }) => {
  let dotIndex = 0;
  return (
    <div
      data-testid={testId}
      className="relative w-full overflow-hidden border border-neutral-200"
    >
      <img src={src} alt={alt} loading="lazy" className="h-auto w-full" />
      <svg
        className="pointer-events-none absolute inset-0 hidden h-full w-full md:block"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        {groups.flatMap((g, gi) =>
          g.points.map((p, pi) => (
            <line
              key={`${gi}-${pi}`}
              x1={p.x}
              y1={p.y}
              x2={8}
              y2={g.position === "top" ? 5 : 95}
              stroke={g.color || "#00A8B5"}
              strokeWidth={g.big ? 2.5 : 1.5}
              vectorEffect="non-scaling-stroke"
              opacity={0.9}
            />
          ))
        )}
      </svg>
      {groups.flatMap((g) =>
        g.points.map((p) => {
          dotIndex += 1;
          const big = !!g.big;
          return (
            <span
              key={dotIndex}
              data-testid={`${testId}-point-${dotIndex}`}
              className={`absolute -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white shadow-[0_2px_8px_rgba(10,17,24,0.4)] ${
                big ? "h-4 w-4 border-[3px] md:h-5 md:w-5" : "h-2.5 w-2.5 md:h-3.5 md:w-3.5"
              }`}
              style={{
                left: `${p.x}%`,
                top: `${p.y}%`,
                backgroundColor: g.color || "#00A8B5",
              }}
            />
          );
        })
      )}
      {groups.map((g) => (
        <span
          key={g.label}
          className={`absolute left-1.5 bg-white/90 px-1.5 py-1 text-[8px] font-semibold uppercase tracking-[0.12em] text-ink backdrop-blur-sm md:left-2 md:px-3 md:py-1.5 md:text-[10px] md:tracking-[0.18em] ${
            g.position === "top" ? "top-1.5 md:top-3" : "bottom-1.5 md:bottom-3"
          }`}
        >
          <span
            className="mr-2 inline-block h-2 w-2 rounded-full align-middle"
            style={{ backgroundColor: g.color || "#00A8B5" }}
          />
          {g.label}
        </span>
      ))}
    </div>
  );
};
